// Environment
export const ENVIRONMENT = process.env.NODE_ENV === 'production' ? '' : 'https://localhost';

// Base name
export const BASE_NAME = process.env.NODE_ENV === 'production' ? '/BoletoNegociacao' : '/';

// Webservices URLs
export const URL_BOLETOS_NEGOCIACAO = ENVIRONMENT + '/SysSAF/rs/negociacao/parcelas-negociacao';
export const URL_BOLETO = ENVIRONMENT + '/SysSAF/rs/negociacao/boleto?cpf=123&negociacao=123&boleto=';

// Message types
export const MESSAGE_INFO = 'info';
export const MESSAGE_ALERT = 'warning';
export const MESSAGE_ERROR = 'error';
export const MESSAGE_SUCCESS = 'success';